import { isDefinedString } from "et3-type-guards";
import getCorePopUpStore from "../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import KhattabatChangePasswordDialog from "./change-password-pop-up/KhattabatChangePasswordDialog";
import EditPopUp from "./edit-pop-up";
import KhattabatNotificationPermissionDialog from "./notification-permission-pop-up/KhattabatNotificationPermissionDialog";
import getCoreUIStore from "../../stores/core/core-ui-store";

const Et3ActionPopUp = withLiteObserverAndTheme(() => {
  const editPopUpVisibleType = isDefinedString(
    getCorePopUpStore().editPopUpVisibleType.get()
  );
  const isShowUpdatePasswordPopUpVisible =
    getCorePopUpStore().isShowUpdatePasswordPopUpVisible.get();
  const isNotificationPermissionPopUpVisible =
    getCorePopUpStore().isNotificationPermissionPopUpVisible.get();
  const mainWidth = getCoreUIStore().mainWidth.get();

  switch (true) {
    case editPopUpVisibleType:
      return <EditPopUp width={mainWidth} />;
    case isShowUpdatePasswordPopUpVisible:
      return <KhattabatChangePasswordDialog />;
    case isNotificationPermissionPopUpVisible:
      return <KhattabatNotificationPermissionDialog />;
    default:
      return <></>;
  }
});
export default Et3ActionPopUp;
